import { FC } from "react"

import Summary from "components/Summary/Summary"
import useArticleDetailsBase from "./hooks/useArticleDetailsBase"
import { ArticleMachineInt } from "models/ArticleMachineInt"
import { ArticleMachineExt } from "models/ArticleMachineExt"

interface IArticleDetailsMachineProps {
    article: ArticleMachineInt | ArticleMachineExt
    onEditInspectionSetting?: () => void
}

const ArticleDetailsMachine: FC<IArticleDetailsMachineProps> = ({
    article,
    onEditInspectionSetting
}) => {
    const detailsBase = useArticleDetailsBase({ article, onEditInspectionSetting })
    return <Summary data={detailsBase} />
}

export default ArticleDetailsMachine
